<template>
  <div>


<h2 class="goth">Die-ord</h2>
<div class="grammatikparagrafbredd leftorient">

<p>Man kan <b>aldrig vara helt säker</b> på om ett tyskt substantiv är ett der-, das- eller die-ord och vilken plural det har
  genom att bara se på hur ordet ser ut eller vad det betyder. Men nedan kommer några av de <b>vanligaste
  reglerna</b> vad som kännetecknar ett die-ord och som kan ge en <b>fingervisning</b> och stämmer i många fall</p>

  <br>
  <h4>die-ord är ofta...</h4>

  <div class="quasi-p"> &#x2022; Substantiv som betecknar personer av kvinnligt kön
  </div>


  <div class="ruta">
  <p>
      <i>die Frau <br>kvinnan</i>
  </p>

  <p>
      <i>die Tochter <br>dottern</i>
  </p>

  <p>
      <i>die Schauspielerin <br>skådespelerskan</i>
  </p>

  </div>

  <br><br>


  <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-e</b>
  </div>


  <div class="ruta">
    <p>
        <i>die Blume <br>blomman</i>
    </p>


  <p>
      <i>die Schule <br>skolan</i>
  </p>

  <p>
      <i>die Woche <br>veckan</i>
  </p>


  </div>
  <br><br>



  <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-ei, heit,- keit, -schaft, -ung</b>
  </div>


  <div class="ruta">
  <p>
      <i>die Partei <br>partiet</i>
  </p>
  <p>
      <i>die Freiheit <br>friheten</i>
  </p>
  <p>
      <i>die Arbeitslosigkeit <br>arbetslösheten</i>
  </p>
  <p>
      <i>die Gesellschaft <br>sällskapet / sammhället</i>
  </p>
  <p>
      <i>die Zeitung <br>tidningen</i>
  </p>



  </div>
  <br><br>


  <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-ie, -ik, -ion, -tät, </b>
  </div>


  <div class="ruta">
  <p>
      <i>die Idiologie <br>idiologin</i>
  </p>
  <p>
      <i>die Grammatik<br>grammatiken</i>
  </p>

  <p>
      <i>die Information<br>informationen</i>
  </p>

  <p>
      <i>die Universität<br>universitetet</i>
  </p>

  <p>
      <i>die Natur<br>naturen</i>
  </p>

  </div>
  <p class="mindre">Observera det viktiga undantaget till den sista regeln: <i>ta studenten</i> heter
    <i><b>das </b> Abitur machen</i>
    </p>
  <br><br>

  <div class="quasi-p"> &#x2022; Substantiv som slutar på bildas av verbstam <b>+t</b> eller <b>+d</b>
  </div>


  <div class="ruta">
  <p>
      <i>die Fahrt <br>färden</i>
  </p>
  <p>
      <i>die Jagd <br>jakten</i>
  </p>
  </div>
  <br>
  <h4>die-ord i plural</h4>
  <p>die-ord som slutar på <b>-e</b> får <b>-n</b> i plural</p>

  <p>die-ord som slutar på <b>-in</b> får <b>-nen</b> i plural</p>

  <p>die-ord som slutar på <b>-heit, -ung </b> m.fl. får <b>-en</b> i plural</p>

  <p>Kort sagt slutar de flesta feminina ord i plural på <b>-n</b> (även om det inte alltid är HELA pluraländelsen)</p>

  <br>





</div>

</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "ob wenn om huruvida"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
